import $ from 'jquery';
import whatInput from 'what-input';

//import 'customizer';
import 'navigation';

window.$ = $;

import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

$(document).foundation();

$(document).ready(function(){
	$('#nav-icon').click(function(){
		$('#nav-icon').toggleClass('open');
		revealOverlay();
	});
});

//////////////////////////////
// Reveal menu with revealOverlay()
//////////////////////////////

function revealOverlay() {
  document.getElementById("overlayMenu").classList.toggle("overlay-reveal");
  document.body.classList.toggle('menu-open');
}

//////////////////////
// Parallax scroll
//////////////////////
var background_image_parallax = function($object, multiplier){
  multiplier = typeof multiplier !== 'undefined' ? multiplier : 0.5;
  multiplier = 1 - multiplier;
  var $doc = $(document);
  $object.css({"background-attatchment" : "fixed"});
  $(window).scroll(function(){
    var from_top = $doc.scrollTop(),
        bg_css = '0px ' +(multiplier * from_top) + 'px';
    $object.css({"background-position" : bg_css });
  });
};
background_image_parallax($(".parallax"));


//Read more / Read less
$(document).ready(function(){
        //length in characters
    var maxLength = 0;
    var ellipsestext = "";
    var moretext = "Les mer";
    var lesstext = "Lukk";
    $(".showReadMore").each(function(){
        //get the text of paragraph or div
        var myStr = $(this).html();

       // check if it exceeds the maxLength limit
        if($.trim(myStr).length > maxLength){
            //get only limited string firts to show text on page load
            var newStr = myStr.substring(0, maxLength);

            //get remaining string
 						var removedStr = myStr.substr(maxLength, $.trim(myStr).length - maxLength);
            // now append the newStr + "..."+ hidden remaining string
            var Newhtml = newStr + '<span class="moreellipses">' + ellipsestext+ '</span><span class="morecontent"><span>' + removedStr + '</span>&nbsp;&nbsp;<a href="javascript:void(0)" class="ReadMore">' + moretext + '</a></span>';

            $(this).html(Newhtml);

        }
    });

    //function to show/hide remaining text on ReadMore button click
    $(".ReadMore").click(function(){

        if($(this).hasClass("less")) {
            $(this).removeClass("less");
            $(this).html(moretext);
        }
         else {
            $(this).addClass("less");
            $(this).html(lesstext);
        }

        $(this).parent().prev().toggle();
        $(this).prev().toggle();
        return false;
    });
});
